<div *ngIf="showPaymentModal" class="payment-modal-overlay">
    <div class="payment-modal">
      <div class="payment-modal-header">
        <!-- <h3 class="text-white"><i class="fa-solid fa-credit-card mr-2"></i> Make Payment</h3> -->
        <button class="close-button" (click)="close()">
          <i class="fa-solid fa-times text-white"></i>
        </button>
      </div>
      <div class="payment-modal-content">
        <div id="checkout-element"></div> <!-- Stripe mounts here -->
      </div>
  
      <div class="payment-modal-actions">
        <button class="cancel-button" (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
  